import React, { useEffect, useState } from "react";

/**
 * Numeric input that users can freely backspace to empty and retype.
 *
 * Classic bug it fixes: controlled inputs whose canonical state is parsed or
 * unit-converted on every keystroke (e.g. lbs → kg) snap an emptied field
 * straight back to "0", so you can't clear the old number before typing a
 * new one. NumField freezes the visible text while the field is focused,
 * commits the raw string upward on each change (caller parses/converts),
 * and re-syncs the display from the canonical `value` on blur.
 */
export default function NumField({ value, onCommit, onFocus, onBlur, ...props }) {
  const [text, setText] = useState(value === 0 || value ? String(value) : "");
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!focused) setText(value === 0 || value ? String(value) : "");
  }, [value, focused]);

  return (
    <input
      type="number"
      inputMode="decimal"
      {...props}
      value={text}
      onFocus={(e) => {
        setFocused(true);
        onFocus?.(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        onBlur?.(e);
      }}
      onChange={(e) => {
        setText(e.target.value);
        onCommit(e.target.value);
      }}
    />
  );
}
